import { AccountingAccountResponse } from '@/app/models/accountingAcount';
import { useListAccountingAccountsQuery } from '@/app/services/accountingAccountApi';
import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import AccountingAccountTable from '@/components/tables/AccountingAccountTable';
import NewEditAccountingAccountScreen from '@/components/uploadFiles/newEditScreen/NewEditAccountingAccountScreen ';
import { Box, Button, Drawer, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function AccountingAccount() {
  const { t } = useTranslation(['accountingAccount', 'common']);

  const { data } = useListAccountingAccountsQuery();

  const [drawerStatus, setDrawerStatus] = useState(false);
  const [selectedItem, setSelectedItem] = useState<AccountingAccountResponse | null>(null);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '1.25rem',
      }}
    >
      <PeriodDetails />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '18px',
              color: '#4b4b4b',
              marginTop: '2rem',
            }}
          >
            {t('common:accounting.accounts')}
          </Typography>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                pr: 3,
                marginTop: '3.125rem',
              }}
            >
              <Box display="flex" flexDirection="row">
                <Button
                  onClick={() => {
                    setSelectedItem(null);
                    setDrawerStatus(true);
                  }}
                  variant="text"
                  sx={{
                    color: '#f97c06',
                    textTransform: 'none',
                    fontWeight: 800,
                    fontSize: 14,
                  }}
                >
                  {` + ${t('add.configuration')}`}
                </Button>
              </Box>
            </Box>
          </div>
        </Box>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '2.5rem',
          width: '100%',
        }}
      >
        <AccountingAccountTable
          rows={data || []}
          setSelectedItem={setSelectedItem}
          setDrawerStatus={setDrawerStatus}
        />
      </div>
      <Drawer
        anchor="right"
        open={drawerStatus}
        onClose={(event: React.SyntheticEvent, reason: string) => {
          setDrawerStatus(false);
        }}
      >
        <NewEditAccountingAccountScreen
          accountingAccount={selectedItem}
          setDrawerOpen={setDrawerStatus}
        />
      </Drawer>
    </div>
  );
}
export default AccountingAccount;
